var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "Step"
  }, [_c('div', {
    staticClass: "Step-iconWrap",
    class: {
      'Step-iconWrap--active text-white': _vm.isActive,
      'Step-iconWrap--completed': _vm.isCompleted,
      'text-dark': !_vm.isActive
    }
  }, [_vm.isActive || !_vm.isCompleted ? _c('div', {
    staticClass: "Step-icon",
    class: {
      'Step-icon--active': _vm.isActive
    }
  }, [_vm._v(" " + _vm._s(_vm.number) + " ")]) : _vm._e(), _vm.isCompleted ? _c('div', {
    staticClass: "Step-icon Step-icon--completed"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]) : _vm._e()]), _c('h4', {
    staticClass: "Step-title d-sm-inline d-none",
    class: {
      'font-weight-bold': _vm.isActive
    }
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }